import React, {ReactNode, useEffect, useState} from 'react';

import '@reach/dialog/styles.css';
import {useTranslation} from 'react-i18next';

import {Icon} from '@shared/ui/Icon';

import {
    DialogCloseButton,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogOverlay,
    DialogTitle,
} from './styled';

interface Props {
    show: boolean;
    onClose: Function;
    children: ReactNode;
    title?: string;
    hideCloseButton?: boolean;
    footer?: ReactNode;
    className?: string;
    modalWidth?: 0 | 1 | 2 | 3;
    closable?: boolean;
}

export function Modal({
    show,
    onClose,
    children,
    title,
    hideCloseButton,
    footer,
    modalWidth,
    className,
    closable = true,
}: Props) {
    const {t} = useTranslation();
    const [visible, setVisible] = useState(show ?? true);

    useEffect(() => {
        if (show === undefined) return;
        if (show) setVisible(true);
        else {
            const timeout = setTimeout(() => setVisible(false), 200);
            return () => clearTimeout(timeout);
        }
    }, [show]);

    if (!visible) return null;

    return (
        <DialogOverlay
            mode={modalWidth}
            className={className}
            open={show}
            onDismiss={() => closable && onClose()}
        >
            <DialogContent
                aria-label={title || t('components.modal.ModalWindow')}
                mode={modalWidth}
                open={show}
            >
                {!hideCloseButton && (
                    <DialogCloseButton
                        icon={<Icon name="cross" color="#C4C4C4" size={12} />}
                        onClick={() => closable && onClose()}
                    />
                )}
                <DialogHeader>{title && <DialogTitle size={4}>{title}</DialogTitle>}</DialogHeader>
                {children}
                {footer && <DialogFooter>{footer}</DialogFooter>}
            </DialogContent>
        </DialogOverlay>
    );
}
